// eslint-disable
// this is an auto generated file. This will be overwritten

export const getEntity = `query GetEntity($id: ID!) {
  getEntity(id: $id) {
    id
    name
    legacyId
    tags
    centers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    programs {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const listEntitys = `query ListEntitys(
  $filter: ModelEntityFilterInput
  $limit: Int
  $nextToken: String
) {
  listEntitys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      legacyId
      tags
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    nextToken
  }
}
`;
export const getCenter = `query GetCenter($id: ID!) {
  getCenter(id: $id) {
    id
    name
    legacyId
    tags
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    spaces {
      items {
        id
        name
        version
      }
      nextToken
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const listCenters = `query ListCenters(
  $filter: ModelCenterFilterInput
  $limit: Int
  $nextToken: String
) {
  listCenters(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      legacyId
      tags
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    nextToken
  }
}
`;
export const getProgram = `query GetProgram($id: ID!) {
  getProgram(id: $id) {
    id
    name
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const listPrograms = `query ListPrograms(
  $filter: ModelProgramFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrograms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      entity {
        id
        name
        legacyId
        version
      }
      groups {
        nextToken
      }
      version
    }
    nextToken
  }
}
`;
export const getSpace = `query GetSpace($id: ID!) {
  getSpace(id: $id) {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentGroups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const listSpaces = `query ListSpaces(
  $filter: ModelSpaceFilterInput
  $limit: Int
  $nextToken: String
) {
  listSpaces(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentGroups {
        nextToken
      }
      version
    }
    nextToken
  }
}
`;
export const getGroup = `query GetGroup($id: ID!) {
  getGroup(id: $id) {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentSpace {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentGroups {
        nextToken
      }
      version
    }
    program {
      id
      name
      entity {
        id
        name
        legacyId
        version
      }
      groups {
        nextToken
      }
      version
    }
    defaultTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    defaultChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    version
  }
}
`;
export const listGroups = `query ListGroups(
  $filter: ModelGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    nextToken
  }
}
`;
export const getTeacher = `query GetTeacher($id: ID!) {
  getTeacher(id: $id) {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const listTeachers = `query ListTeachers(
  $filter: ModelTeacherFilterInput
  $limit: Int
  $nextToken: String
) {
  listTeachers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      legacyId
      defaultGroup {
        id
        name
        version
      }
      currentGroup {
        id
        name
        version
      }
      version
    }
    nextToken
  }
}
`;
export const getChild = `query GetChild($id: ID!) {
  getChild(id: $id) {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const listChilds = `query ListChilds(
  $filter: ModelChildFilterInput
  $limit: Int
  $nextToken: String
) {
  listChilds(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      legacyId
      defaultGroup {
        id
        name
        version
      }
      currentGroup {
        id
        name
        version
      }
      version
    }
    nextToken
  }
}
`;
